/**
 * services/settings/settings.ts — tenant settings + DPDP erasure.
 */
import { axiosInstance, unwrap, withFallback } from '../client';
import { Upsell_Settings_Url, Upsell_Dpdp_Erase_Url } from '../../api-endpoints/endpoints';
import { Settings, SettingsPatch } from '../../schema/settings';
import { Seed } from '../_demo/seed';

export function getSettings(): Promise<Settings> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.get(Upsell_Settings_Url);
      return unwrap<Settings>(data);
    },
    () => Seed.settings(),
  );
}

export function updateSettings(patch: SettingsPatch): Promise<Settings> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.patch(Upsell_Settings_Url, patch);
      return unwrap<Settings>(data);
    },
    () => ({ ...Seed.settings(), ...patch }) as Settings,
  );
}

export function eraseContact(contactId: string): Promise<{ purged: number }> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.post(Upsell_Dpdp_Erase_Url, { contact_id: contactId });
      return unwrap<{ purged: number }>(data);
    },
    () => ({ purged: 0 }),
  );
}
